import React, { useState, useEffect } from "react";
import "../styles/ProfileDetails.css";
import eyeIcon from "../assets/Show.png";
import eyeOffIcon from "../assets/Hide.png";
import deleteicon from "../assets/delete.png";
import icon from "../assets/rightArrow.png";
import checkicon from "../assets/check.png";

import { useLocation, useNavigate } from "react-router-dom";
import {
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
  deleteUser,
  updateProfile,
} from "firebase/auth";

import { getFirestore, doc, getDoc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const ProfileDetails = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  var tab;
  const [selectedSection, setSelectedSection] = useState(tab);
  const [selectedPlan, setSelectedPlan] = useState("Free Plan");
  const [billingCycle, setBillingCycle] = useState("Monthly");
  const [selectedTab, setSelectedTab] = useState("Password");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [url, setUrl] = useState(null);

  const auth = getAuth();
  const firestore = getFirestore();
  const user = auth.currentUser;
  const [userData, setUserData] = useState({
    username: "",
    email: "",
  });

  useEffect(() => {
    if (!tab) {
      if (location.state?.tab) {
        tab = location.state?.tab;
        setSelectedSection(tab);
      }
      if (tabs) {
        tab = tabs;
        setSelectedSection(tab);
        console.log("i have set the value of tab like ", tab);
      } else {
        tab = "Profile Details";
        setSelectedSection(tab);
      }
    }
    if (user) {
      const fetchUserData = async () => {
        console.log("/*/*/*/*/*/*/*/*/*/*/*/ ", selectedSection);
        console.log("tabs", tabs);
        const userDoc = doc(firestore, "users", user.uid);
        const userSnapshot = await getDoc(userDoc);
        if (userSnapshot.exists()) {
          setUserData(userSnapshot.data());
        }
      };
      fetchUserData();
    }
  }, [user, firestore]);

  const plans = [
    {
      name: "Free Plan",
      description: "Get started with our startup package",
      price: "Free",
      features: [
        "Fast Processing",
        "All Styles & Models",
        "Commercial License",
        "Limited Support",
        "Basic Features",
        "No Customization",
        "Community Access",
        "Standard Quality",
        "Limited Models",
      ],
    },
    {
      name: "Standard Plan (Save 60%)",
      description: "Get started with our standard package",
      price: "$ 20.00",
      features: [
        "Enhanced Processing",
        "Full Styles & Models",
        "Extended Commercial License",
        "Priority Support",
        "Advanced Features",
        "Basic Customization",
        "Premium Community Access",
        "High Quality",
        "Extensive Models",
      ],
    },
    {
      name: "Premium Plan",
      description: "Get started with our premium package",
      price: "$ 39.99",
      features: [
        "Fastest Processing",
        "All Styles & Premium Models",
        "Full Commercial License",
        "Dedicated Support",
        "All Features",
        "Full Customization",
        "Exclusive Community Access",
        "Ultra Quality",
        "All Models",
      ],
    },
  ];

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  const togglePasswordVisibility3 = () => {
    setShowPassword3(!showPassword3);
  };

  const handlePhotoChange = async (event) => {
    const file = event.target.files[0];
    const storage = getStorage();
    const storageRef = ref(storage, `profilePictures/${file.name}`);

    try {
      // Upload the file to Firebase Storage
      await uploadBytes(storageRef, file);

      // Get the download URL for the uploaded file
      const downloadURL = await getDownloadURL(storageRef);

      // Update the user's profile with the new photo URL
      setUrl(downloadURL);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateProfile = async () => {
    if (user) {
      try {
        await updateProfile(user, {
          displayName: userData.username,
          photoURL:
            url ||
            "https://firebasestorage.googleapis.com/v0/b/katanainu-ai.appspot.com/o/profileicon.png?alt=media&token=f3d7e0e7-0039-4dd2-85bc-45737ddb087f",
        });

        console.log("User profile updated successfully");
      } catch (error) {
        console.error("Error updating user profile:", error);
      }
    } else {
      console.log("No user is signed in");
    }
  };

  const handleUpdatePassword = async () => {
    if (user && currentPassword && newPassword) {
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword
      );
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      alert("Password updated successfully!");
    } else {
      alert("Please fill in all fields.");
    }
  };

  const handleDeleteAccount = async () => {
    if (user && currentPassword) {
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword
      );
      await reauthenticateWithCredential(user, credential);
      await deleteUser(user);
      await deleteDoc(doc(firestore, "users", user.uid));
      alert("Account deleted successfully!");
      navigate("/signup");
    } else {
      console.log("+++++++++++++++++++++++++++++++++", user);
      console.log("current password   ", currentPassword);
      alert("Please enter your password to delete your account.");
    }
  };

  return (
    <div
      className="profile-page-container"
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <div className="scroller">
        <div className="content-area">
          {selectedSection === "Plans And Billing" && (
            <h1 className="page-title">Plans And Billing</h1>
          )}
          {selectedSection === "Profile Details" && (
            <h1 className="page-title">Profile Details</h1>
          )}
          <div className="nav-bar">
            <div
              className={`nav-item ${
                selectedSection === "Profile Details" ? "active" : ""
              }`}
              onClick={() => setSelectedSection("Profile Details")}
            >
              Profile Details
            </div>
            <div
              className={`nav-item ${
                selectedSection === "Plans And Billing" ? "active" : ""
              }`}
              onClick={() => setSelectedSection("Plans And Billing")}
            >
              Plans And Billing
            </div>
          </div>
          {selectedSection === "Plans And Billing" && (
            <div className="pricing-page">
              <div className="billing-cycle">
                <div className="cycle-container">
                  <button
                    className={billingCycle === "Monthly" ? "selected" : ""}
                    onClick={() => setBillingCycle("Monthly")}
                  >
                    Monthly
                  </button>
                  <button
                    className={billingCycle === "Yearly" ? "selected" : ""}
                    onClick={() => setBillingCycle("Yearly")}
                  >
                    Yearly
                  </button>
                </div>
              </div>
              <div className="plans">
                {plans.map((plan, index) => (
                  <div
                    key={index}
                    className={`plan-box ${
                      selectedPlan === plan.name ? "selected" : ""
                    }`}
                    onClick={() => setSelectedPlan(plan.name)}
                  >
                    <div className="plan-details">
                      <h2>{plan.name}</h2>
                      <p>{plan.description}</p>
                      <h3 style={{ color: "#7064E9", fontSize: 30 }}>
                        {plan.price}
                      </h3>
                    </div>
                    <button
                      className={`join-button ${
                        selectedPlan === plan.name ? "selected" : ""
                      }`}
                    >
                      Join this plan{" "}
                      <img src={icon} alt="Icon" className="button-icon" />
                    </button>
                    <ul
                      style={{
                        fontFamily: "Inter",
                        color: "#7376AA",
                        fontSize: 13,
                      }}
                    >
                      {plan.features.map((feature, i) => (
                        <li key={i}>
                          <br></br>
                          <br></br>
                          <img
                            src={checkicon}
                            alt="Icon"
                            className="button-icon"
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}

          {selectedSection === "Profile Details" && (
            <div className="profile-section">
              <div className="tab-bar">
                {/* <div
                  className={`tab-item ${
                    selectedTab === "Profile" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("Profile")}
                >
                  Profile
                </div> */}
                <div
                  className={`tab-item ${
                    selectedTab === "Password" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("Password")}
                >
                  Update Password
                </div>
                {/* <div
                  className={`tab-item ${
                    selectedTab === "Delete Account" ? "active" : ""
                  }`}
                  onClick={() => setSelectedTab("Delete Account")}
                >
                  Delete Account
                </div> */}
              </div>

              {selectedTab === "Profile" && (
                <div className="form-area">
                  <label htmlFor="currentPassword">User Name:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        id="username"
                        placeholder="User name"
                        className="input-field"
                        value={userData.username}
                        onChange={(e) =>
                          setUserData({
                            ...userData,
                            username: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="newPassword">Email:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        id="email"
                        placeholder="Email Address"
                        className="input-field"
                        value={userData.email}
                        readonly="readonly"
                        onChange={(e) =>
                          setUserData({ ...userData, email: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="profilePhoto">Profile Photo:</label>
                  <div className="form-row full-width">
                    <div className="photo-upload-wrapper">
                      <input
                        type="file"
                        id="profilePhoto"
                        className="photo-upload-field"
                        onChange={handlePhotoChange}
                      />
                      {selectedPhoto && (
                        <img
                          src={selectedPhoto}
                          alt="Profile Preview"
                          className="photo-preview"
                        />
                      )}
                    </div>
                  </div>
                  <button
                    className="update-button"
                    onClick={handleUpdateProfile}
                  >
                    Update Info
                  </button>
                </div>
              )}

              {selectedTab === "Password" && (
                <div className="form-area">
                  <label htmlFor="currentPassword">Current Password:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="currentPassword"
                        placeholder="Enter Current Password"
                        className="password-field"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <img
                        src={showPassword ? eyeIcon : eyeOffIcon}
                        alt="Toggle Password Visibility"
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                  </div>
                  <label htmlFor="newPassword">New Password:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword1 ? "text" : "password"}
                        id="newPassword"
                        placeholder="Enter New Password"
                        className="password-field"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <img
                        src={showPassword1 ? eyeIcon : eyeOffIcon}
                        alt="Toggle Password Visibility"
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility1}
                      />
                    </div>
                  </div>
                  <label htmlFor="confirmPassword">Confirm Password:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword2 ? "text" : "password"}
                        id="confirmPassword"
                        placeholder="Enter Confirm Password"
                        className="password-field"
                      />
                      <img
                        src={showPassword2 ? eyeIcon : eyeOffIcon}
                        alt="Toggle Password Visibility"
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility2}
                      />
                    </div>
                  </div>
                  <button
                    className="update-button"
                    onClick={handleUpdatePassword}
                  >
                    Update Password
                  </button>
                </div>
              )}

              {selectedTab === "Delete Account" && (
                <div className="form-area">
                  <p className="warning-text">
                    <span className="warning-bold">Warning: </span>
                    Deleting your account will permanently erase all your data{" "}
                    and cannot be reversed. <br></br>This includes your profile,
                    conversations, comments, and any other info linked to your
                    account. <br></br>Are you sure you want to go ahead with
                    deleting your account? <br></br>
                    <br></br>Enter your password to confirm.{" "}
                  </p>
                  <label htmlFor="currentPassword">Current Password:</label>
                  <div className="form-row full-width">
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword3 ? "text" : "password"}
                        id="currentPassword"
                        placeholder="Enter Current Password"
                        className="password-field"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <img
                        src={showPassword3 ? eyeIcon : eyeOffIcon}
                        alt="Toggle Password Visibility3"
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility3}
                      />
                    </div>
                  </div>

                  <button
                    className="delete-button"
                    onClick={handleDeleteAccount}
                  >
                    {" "}
                    <img src={deleteicon} alt="Icon" className="button-icon" />
                    Delete Account
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
